<template>
  <div class="buy">
    <div class="buy-top">
      <div class="text-box">
        <p :class="detail.code === 'CASE_SOURCE_LOCK_TIME' && 'only-one'">{{detail.name}}</p>
        <p v-if="detail.code === 'CASE_SOURCE_LOCK_COUNT'">单次可锁定{{hour}}小时</p>
      </div>
    </div>
    <van-cell-group class="buy-member buy-member-bold">
      <!-- <van-cell title="会员分类" :value="detail.name" /> -->
      <van-cell title="订单价格">
        <template #right-icon>
          <span class="members-price">￥{{ detail.discountsPrice }}</span>
        </template>
      </van-cell>
    </van-cell-group>
    <!-- <h4>请选择支付方式</h4> -->
    <van-cell-group class="buy-member" :border="false">
      <van-cell title="订单价格">
        <template #title>
          <img src="@/assets/imgs/members/wx.png" alt="微信" />
          <span class="custom-title">微信支付</span>
					<!-- <span>(微信还需支付{{ wxMoney }}元)</span> -->
        </template>
        <template #right-icon>
          <div @click="selectPay('payWx')">
            <img
              v-if="payWx"
              src="@/assets/imgs/services/buy-checked.png"
              alt="选中"
            />
            <img v-else src="@/assets/imgs/services/uncheck.png" alt="未选中" />
          </div>
        </template>
      </van-cell>
      <van-cell title="会员金额">
        <template #title>
          <img src="@/assets/imgs/members/wallet.png" alt="微信" />
          <span class="custom-title">钱包余额支付</span>
          <label>({{ myWallet }}元)</label>
        </template>
        <template #right-icon>
          <div @click="selectPay('payWallet')">
            <img
              v-if="payWallet"
              src="@/assets/imgs/services/buy-checked.png"
              alt="选中"
            />
            <img v-else src="@/assets/imgs/services/uncheck.png" alt="未选中" />
          </div>
        </template>
      </van-cell>
    </van-cell-group>
    <div class="flex service">
      <div @click="selectService">
        <img v-if="isAgree" src="@/assets/imgs/members/xz.png" alt="未选中" />
        <img v-else src="@/assets/imgs/members/uncheck.png" alt="选中" />
      </div>
      <span>支付即代表同意 <a :href="proUrl">《增值服务购买协议》</a></span>
    </div>
    <div class="count-down" v-if="type === 'buy_times'">
      请在<CountDown :time="lockTime"/>内完成支付，否则案源将释放
    </div>
    <div class="footer tc">
      <button @click="submit">立即支付</button>
    </div>
  </div>
</template>

<script>
import CountDown from '@/components/countdown'
import { priceYuan } from "@/libs/tool";
import { getServicesDetail,getServicesDetailValue,getServicesPay,caseisExtend } from "@/api/services";
import { walletBalance, userAgreement } from "@/api/members";
import { POINT_CODE, BURY_POINT_TYPE, BEHAVIOR } from '@/libs/config'
import { buriedChannelPoint } from '@/api/common'
// import { callApp } from "@/libs/bridge";
export default {
  name: "bug",
  data() {
    return {
			priceYuan,
			goodsId:this.$basicsTools.getQueryUrl('goodsId'),
			lockId:this.$basicsTools.getQueryUrl('lockId'),
			// lockTime:new Date(this.$basicsTools.getQueryUrl('lockTime')).getTime(),//倒计时时间
			lockTime:Number(this.$basicsTools.getQueryUrl('lockTime')),//倒计时时间时间戳
			type:this.$basicsTools.getQueryUrl('type'),//type="buy_times" 延时服务 type="buy_count"次数 type="buy_service"增值服务
      detail: {},
			hour: 0,//锁定时长
      isAgree: false,
      payWx: 0, //0未为微信，1为余额
      payWallet: 0, //0未为微信，1为余额

      discountsPrice: 0, //价格
			// wxMoney: 0,//微信需支付的价格
      myWallet: 0, //余额
      proUrl: null,
    };
  },
  created() {
		console.log('goodsId:', this.goodsId)
		console.log('lockTime:', this.lockTime)
		console.log('type:', this.type)
		this.getQuery()
		this.getServicesDetail()
    this.getBalance();
    this.getuserAgreement();
  },
  async mounted(){
    // 锁定次数埋点
    this.type !== 'buy_times' && await this.buriedPointCountPage()
  },
  components: {
    CountDown
  },
	watch: {
		// payWx(val){//微信
		// 	if(!val) this.wxMoney = 0
		// 	this.wxMoney = (val && this.payWallet) ? this.discountsPrice - this.myWallet : this.discountsPrice
		// },
		// payWallet(val){//余额
		// 	this.wxMoney = val? this.discountsPrice - this.myWallet : this.discountsPrice
		// }
	},
  methods: {
		async buriedPointCountPage() {//页面埋点曝光 增值服务延长锁定次数订单确认页
      let params = {
        code: POINT_CODE.LS_SDCS_FWBXZTC_PAGE,
        type: BURY_POINT_TYPE.PAGE,
        behavior: BEHAVIOR.VI,
      };
      await buriedChannelPoint(params);
    },
		async buriedPointPage() {//页面埋点 // CASE_SOURCE_LOCK_COUNT: 案源广场
      let params = {
        code: this.detail.code === 'CASE_SOURCE_LOCK_COUNT' ? POINT_CODE.CASE_SQUARE_ACCESS_PAY_PAGE : POINT_CODE.COMMON_CONSULE_ACCESS_PAY_PAGE,
        type: BURY_POINT_TYPE.PAGE,
      };
      await buriedChannelPoint(params);
    },
		getQuery(){
			localStorage.setItem('SERVICESINFOS' , JSON.stringify(this.$route.query))
		},
		getServicesDetail(){
			getServicesDetail(this.goodsId).then((res)=>{
				if(!res.code) {
					res.data.discountsPrice = priceYuan(res.data.discountsPrice)
					this.detail = res.data
					this.buriedPointPage()
					// 当code是CASE_SOURCE_LOCK_COUNT调用
					res.data.code === 'CASE_SOURCE_LOCK_COUNT' && getServicesDetailValue({code:'CASE_SOURCE_LOCK_TIME'}).then((resp)=>{
						!res.code && (this.hour = resp.data)
					})
				}
			})
		},
    // priceYuan,
    //  获取钱包余额
    getBalance() {
      walletBalance().then((res) => {
        if (!res.code) {
          this.myWallet = res.data && res.data.amount;
          // this.wxMoney = this.myWallet<this.detail.discountsPrice ? (this.detail.discountsPrice - this.myWallet) : 0
        }
      });
    },
    selectService() {
      this.isAgree = !this.isAgree;
    },
    // 选择支付方式
    selectPay(val) {
      this[val] = this[val] ? 0 : 1;
    },
    // 获取协议
    getuserAgreement() {
      userAgreement({ type: 6 }).then((res) => {
        if (!res.code) {
          this.proUrl = res.data[0].url;
        }
      });
    },
    // 确定支付
    submit() {
      this.$toast.loading({
        message: "正在跳转支付，请稍等...",
        forbidClick: true,
        duration: 0,
      });
      if (!this.isAgree) return this.$toast("请勾选增值服务购买协议！");
      if (!this.payWx && !this.payWallet)
        return this.$toast("请选择付款方式！");
			let params = {
        code: this.detail.code === 'CASE_SOURCE_LOCK_COUNT' ? POINT_CODE.CASE_SQUARE_ORDER_PAY_BUTTON : POINT_CODE.COMMON_CONSULE_PAY_BUTTON,
        type: BURY_POINT_TYPE.FRONTEVENT,
      };
      buriedChannelPoint(params);
      // 锁定次数支付按钮埋点
			let paramsCount = {
        code: POINT_CODE.LS_SDCS_LJZF_BUTTON,
        type: BURY_POINT_TYPE.FRONTEVENT,
        behavior: BEHAVIOR.CK
      };
      this.type !== 'buy_times' && buriedChannelPoint(paramsCount);
      /**
       * 单个支付方式
       * lawsuitShare、微信直接 2 或者余额直接支付 3
       * 组合支付 4
       * lawsuitShare、先查看余额是否有钱
       * 2、金额是大于会员价格 大于的话，直接购买成功
       * 3、小于的话，先扣余额的所有金额，然后再调起微信支付
       *
       */
      const priceDiff = (
        Number(this.myWallet) - Number(this.detail.discountsPrice)
      ).toFixed(2); //余额和价格的差价
      let payType =
        (this.payWx && this.payWallet && priceDiff <= 0 && 4) ||
        (this.payWx && this.payWallet && priceDiff > 0 && 3) ||
        (!this.payWx && this.payWallet && 3) ||
        (this.payWx && !this.payWallet && 2) ||
        null; //购买方式

      if (payType === 3 && priceDiff < 0)
        return this.$toast("余额不足，请选择其他支付方式！");

      const prams = {
        businessParam: this.lockId || '',
        productId: this.detail.goodsId,
        payType,
        price: this.detail.discountsPrice * 100, //接受分
      };
			console.log('params:', prams)
      // 支付前校验是否还能支付（延长）
      this.type === 'buy_times' ?
     ( caseisExtend(this.lockId).then((resp)=>{
        if(!resp.code){
          if(resp.data){
              // 下订单
            this.toGetServicesPay(prams, payType)
          }else{
            return this.$toast('购买超时，案源已释放')
          }
        }else{
          this.$toast(resp.message)
        }
      })):
        // 下订单
        this.toGetServicesPay(prams, payType)
    },
      // 下订单
    toGetServicesPay(prams, payType){
        getServicesPay(prams).then((res) => {
          if (!res.code) {
            const obj = JSON.parse(JSON.stringify(res.data));
            const h5 = res.data.payResultMsg && JSON.parse(res.data.payResultMsg);
  
            // 余额和余额+微信混合支付，跳转
            if (payType !== 2) {
              if (Number(this.myWallet) === 0 && payType === 4)
                return (window.location.href = h5.h5_url);
              this.$router.push({
                name: "servicesPassword",
                query: { infos: encodeURIComponent(JSON.stringify(obj)) },
              });
            } else {
              // 微信支付
              window.location.href = h5.h5_url;
            }
  
            this.$toast.clear();
          }else{
            this.$toast(res.message)
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.buy {
  height: 100vh;
  background: #f5f5f7;
  color: #46474b;
}
.buy-top {
  background: url("../../assets/imgs/services/bg@2x.png");
  background-size: 100% 100% !important;
  height: 123px;
  display: flex;
  justify-content: flex-end;
  .text-box {
    color: #fff;
    height: 100%;
    box-sizing: border-box;
    padding: 32px 20px;
		.only-one{
			height: 100%;
			line-height: 70px;
		}
    p:nth-child(1) {
      font-size: 21px;
      font-weight: 600;
      margin-bottom: 10px;
    }
    p:nth-child(2) {
      font-size: 15px;
      font-weight: 500;
    }
  }
}
.buy-member-bold {
    .van-cell {
    font-weight: 600;
    color: #333333 !important;
    font-size: 17px !important;
  }
}
.buy-member {
  .van-cell {
    color: #46474b !important ;
  }
  .members-price {
    color: #4a549e;
    font-size: 17px;
    font-weight: 600;
  }

  img {
    width: 18px;
    height: 18px;
    vertical-align: middle;
    margin-right: 5px;
  }

  label {
    color: #4a549e;
    font-weight: 600;
  }
}
// h4{
//     line-height: 40px;
//     font-size: 13px;
//     padding: 0 16px;
//     font-weight: normal;
// }
.service {
  padding: 16px;
  img {
    width: 15px;
    height: 15px;
    vertical-align: middle;
    position: relative;
    top: 2px;
    margin-right: 5px;
  }
  a {
    color: #d4b37d;
  }
}
.count-down{
  width: 100%;
  font-weight: 500;
  color: #46474B;
  font-size: 14px;
  display: flex;
  justify-content: center;
  position: fixed;
  bottom: 80px;
  ::v-deep p{
    color: #F34747;
    font-size: 17px;
  }
}
.footer {
  position: fixed;
  bottom: 20px;
  width: 100%;

  button {
    width: 90%;
    line-height: 40px;
    background: #4a549e;
    color: #ffffff;
    font-size: 15px;
    outline: none;
    border: none;
    border-radius: 44px;
  }
}
.van-nav-bar .van-icon{
	color: #000 !important;
}
</style>
